function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHtml5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "27px",
    height: "27px",
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(89.019608%,30.980392%,14.901961%)",
      fillOpacity: 1
    },
    d: "M 3.742188 24.257812 L 1.582031 0 L 25.367188 0 L 23.203125 24.257812 L 13.445312 27 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.72549%,39.607843%,16.470588%)",
      fillOpacity: 1
    },
    d: "M 13.5 24.890625 L 21.359375 22.726562 L 23.203125 1.953125 L 13.5 1.953125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.156863%,92.156863%,92.156863%)",
      fillOpacity: 1
    },
    d: "M 13.5 10.96875 L 9.546875 10.96875 L 9.28125 7.910156 L 13.5 7.910156 L 13.5 4.957031 L 6.011719 4.957031 L 6.804688 13.976562 L 13.5 13.976562 Z M 13.445312 18.71875 L 10.125 17.824219 L 9.914062 15.453125 L 6.960938 15.453125 L 7.328125 20.144531 L 13.445312 21.832031 Z M 13.445312 18.71875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 13.445312 10.96875 L 13.445312 13.976562 L 17.140625 13.976562 L 16.769531 17.824219 L 13.445312 18.71875 L 13.445312 21.832031 L 19.5625 20.144531 L 20.40625 10.96875 Z M 13.445312 4.957031 L 13.445312 7.910156 L 20.671875 7.910156 L 20.9375 4.957031 Z M 13.445312 4.957031 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml5);
export default __webpack_public_path__ + "static/media/html5.69b2e1e4db69442fcdd423143ca253ee.svg";
export { ForwardRef as ReactComponent };